import { atom } from "recoil";

export const saladOptionsAtom = atom({
  key: "saladOptions",
  default: { saladData: {}, saladItems: [] },
});

export default saladOptionsAtom;
